import React from 'react'
import styled from '@emotion/styled'
import RightArrow from 'src/components/atoms/RightArrow'
import { BreakPoint } from 'src/components/shared/CssValues'
import { Typography } from 'src/components/atoms/Typography'

const MoreRead = ({ tag: Tag = LinkButton, ...props }) => {
  return (
    <Tag {...props}>
      <Wrapper>
        <Text>もっと見る</Text>
        <RightArrowWrapper>
          <RightArrow />
        </RightArrowWrapper>
      </Wrapper>
    </Tag>
  )
}

const LinkButton = styled.a`
  text-decoration: none;
`

const Wrapper = styled.div`
  position: relative;
  width: 190px;
  border-bottom: solid 1px #22475d;
  padding-bottom: 13px;

  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    width: 130px;
  }
`

const Text = styled(Typography)`
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.21;
  letter-spacing: normal;
  text-align: left;
  color: #22475d;
`

const RightArrowWrapper = styled.div`
  position: absolute;
  top: 2px;
  right: 0;
  fill: #22475d;
`

export default MoreRead
